// extracted by mini-css-extract-plugin
export default {"loadingSpinnerInline":"LoadingSpinnerInline_loadingSpinnerInline__LSef-","loadingSpinnerElement":"LoadingSpinnerInline_loadingSpinnerElement__Jo9Mz"};